<template>
    <div style="margin: 5px;">
        <InputGroup>
        <InputGroupAddon>User Name</InputGroupAddon>
        <InputText placeholder="User Name"
                :class="{'p-invalid': isError}" 
                v-model="value" 
                :disabled="disabled"
                :required="required"
                    />
        </InputGroup>

    </div>
    

    <!-- <div class="textbox">
        <label>UserName</label>
        <div>
            <InputText placeholder="User Name"
            :class="{'p-invalid': isError}" 
            v-model="value" 
            :disabled="disabled"
            :required="required"
                />
        </div>
    </div> -->
</template>  
<script>

export default {
    props: ["modelValue", 'disabled','required'],
    emits:["update:modelValue","update:error"],
    data() {
        return {
            value: ""
        }
    },
    created() {
        this.value = this.modelValue
    },
    mounted(){
        this.value = (this.modelValue);
        this.$emit("update:error", this.isError);
      },
    watch: {
            modelValue: function (newVal, oldVal) {
              // watch it
              console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.value = this.modelValue
            },
            value: function (newVal, oldVal) {
              // watch it
              console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
              this.$emit("update:error", this.isError);
            },
          },
    computed:{
        isError(){
            return  !this.value;
        }
    },
    methods: {
      
    }
}
</script>
 